import { Button, Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { GeneralInformationForm } from "./forms/generalInformationForm";
import { ProductIdentityForm } from "./forms/productIdentityForm";
import { ShippingDimensionsForm } from "./forms/shippingDimensionsForm";
import { UnitsConfigurationForm } from "./forms/unitsConfigurationForm";
import { ComercialInfoForm } from "./forms/comercialInfoForm";
import { ShelfLifeForm } from "./forms/shelfLifeForm";
import { PresentationForm } from "./forms/presentationForm";
import { useEffect } from "react";

const defaultValues = {
  shipperId: null,
  categoryId: null,
  subCategoryId: null,
  presentation: "",
  productName: "",
  abbreviation: "",
  productDescription: "",
  sku: "",
  masterSku: "",
  barcode: "",
  unitWeight: "",
  weight: null,
  unitDimensions: "",
  width: "",
  height: "",
  length: "",
  receiptUnitMeasure: "",
  dispatchUnitMeasure: "",
  currency: "",
  pricePerUnit: "",
  price: null,
  shelfLifeDays: "",
  maxDispatchDays: "",
  image: "",
};

const ProductModalFormComponent = ({
  show = false,
  rowEdited = null,
  successfulCreateProduct = false,
  successfulUpdateProduct = false,
  successfulReadProduct = false,
  setShow = () => {},
  reduxResetProductForm = () => {},
  reduxPatchProduct = () => {},
  reduxPostProduct = () => {},
}) => {
  const methods = useForm({
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    if (rowEdited) {
      reduxPatchProduct({
        ...data,
        sku: rowEdited?.sku || data?.sku || "",
        barcode: data?.barcode || rowEdited?.barcode || "",
        isActive: rowEdited?.isActive,
        id: rowEdited.idProduct
      });
    } else {
      reduxPostProduct(data);
    }

    handleClose();
  };

  const handleClose = () => {
    reduxResetProductForm();
    methods.reset(defaultValues);
    setShow(false);
  };

  useEffect(() => {
    if (!rowEdited) {
      methods.reset(defaultValues);
    };
    methods.reset({
      shipperId: rowEdited?.idCompany,
      categoryId: rowEdited?.idCategory,
      subCategoryId: rowEdited?.idSubCategory,
      presentation: rowEdited?.presentation,
      productName: rowEdited?.name,
      abbreviation: rowEdited?.abbreviation,
      productDescription: rowEdited?.description,
      sku: rowEdited?.sku,
      masterSku: rowEdited?.masterSku,
      barcode: rowEdited?.barcode || "",
      unitWeight: rowEdited?.unitWeight?.toUpperCase() ?? "",
      weight: rowEdited?.weight ? parseFloat(rowEdited?.weight) : null,
      unitDimensions: rowEdited?.unitDimensions?.toUpperCase() ?? "",
      width: rowEdited?.width,
      height: rowEdited?.height,
      length: rowEdited?.length,
      receiptUnitMeasure: rowEdited?.receiptUnitMeasure,
      dispatchUnitMeasure: rowEdited?.dispatchUnitMeasure,
      currency: rowEdited?.currency,
      pricePerUnit: rowEdited?.pricePerUnit,
      price: rowEdited?.price ? parseFloat(rowEdited?.price) : null,
      shelfLifeDays: rowEdited?.shelfLifeDays || "",
      maxDispatchDays: rowEdited?.maxDispatchDays || "",
      image: rowEdited?.image || ""
    });
  }, [show, successfulReadProduct]);

  useEffect(() => {
    if (!successfulUpdateProduct && !successfulUpdateProduct) return;
    methods.reset(defaultValues);
    reduxResetProductForm();
    setShow(false);
  }, [successfulCreateProduct, successfulUpdateProduct]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      onEscapeKeyDown={handleClose}
      backdrop="static"
      keyboard={true}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>{rowEdited ? "Editar" : "Nuevo"} Producto</Modal.Title>
      </Modal.Header>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Modal.Body>
            <GeneralInformationForm />
            <br />
            <ProductIdentityForm />
            <br />
            <ShippingDimensionsForm />
            <br />
            <UnitsConfigurationForm />
            <br />
            <ComercialInfoForm />
            <br />
            <ShelfLifeForm />
            <br />
            <PresentationForm />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={!methods.formState.isDirty}>
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    rowEdited: state.productState.rowEdited,
    successfulCreateProduct: state.productState.successfulCreateProduct,
    successfulUpdateProduct: state.productState.successfulUpdateProduct,
    successfulReadProduct: state.productState.successfulReadProduct,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxPostProduct: (payload) =>
      dispatch({
        type: "CREATE_PRODUCT_REQUEST",
        value: payload,
      }),
    reduxPatchProduct: (payload) =>
      dispatch({
        type: "UPDATE_PRODUCT_REQUEST",
        value: payload,
      }),
    reduxResetProductForm: () =>
      dispatch({
        type: "RESET_PRODUCT_FORM",
      }),
  };
};

export const ProductModalForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductModalFormComponent);
